import styled, { css } from 'styled-components'

export const TitleButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CloseButton = styled.button<{ small?: boolean }>`
  color: var(--light);
  background-color: var(--light);
  height: 1.5rem;
  width: 1.5rem;
  padding: 0;
  svg {
    width: 100%;
    height: 100%;
  }
  svg path {
    fill: var(--dark);
  }

  ${({ small }) =>
    !small &&
    css`
      @media screen and (min-width: 48rem) {
        height: 2rem;
        width: 2rem;
      }
    `}
`
